import { render, staticRenderFns } from "./HeartNews.vue?vue&type=template&id=f1e88118"
import script from "./HeartNews.vue?vue&type=script&lang=js"
export * from "./HeartNews.vue?vue&type=script&lang=js"
import style0 from "./HeartNews.vue?vue&type=style&index=0&id=f1e88118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports